import React from 'react';
import { Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="py-12 bg-[#3D3D3D]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo/Name */}
          <div className="text-center md:text-left">
            <h3 className="font-playfair text-lg text-[#FAF8F5] mb-1">
              Divyanka Karmakar
            </h3>
            <p className="font-inter text-xs tracking-widest uppercase text-[#8B7355]">
              Leather Accessories Designer
            </p>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <a
              href="https://www.linkedin.com/in/divyanka-karmakar-a0a88778/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center border border-[#5A5A5A] text-[#C4B5A4] hover:border-[#8B7355] hover:text-[#FAF8F5] hover:bg-[#8B7355] transition-all duration-300"
              aria-label="LinkedIn Profile"
            >
              <Linkedin size={18} />
            </a>
          </div>
        </div>

        {/* Decorative Line */}
        <div className="w-full h-[1px] bg-[#5A5A5A]/50 mt-8" />

        {/* Copyright & Legal Disclaimer */}
        <div className="mt-6 text-center">
          <p className="font-inter text-xs text-[#8B8B8B] leading-relaxed max-w-3xl mx-auto">
            © 2026 Divyanka Karmakar. All Rights Reserved. All designs and technical drawings are the intellectual property of Divyanka Karmakar. Unauthorized reproduction is prohibited.
          </p>
        </div>

        {/* Bottom Tagline */}
        <p className="font-inter text-[10px] text-center text-[#6A6A6A] tracking-widest uppercase mt-4">
          Bespoke Leather Design & Brand Consultancy
        </p>
      </div>
    </footer>
  );
};

export default Footer;
